module.exports = __webpack_public_path__ + "static/card-147edf25c0db8648fe71f818f0a5e9ad.jpg";